// extracted by mini-css-extract-plugin
module.exports = {"nav-link":"NavigationItem_nav-link__UqBAo","nav-link-item":"NavigationItem_nav-link-item__1v02o","selected":"NavigationItem_selected__1Ktnh"};